// extracted by mini-css-extract-plugin
module.exports = {"draft-qty-container":"VIP_DraftQuantity__draft-qty-container","draftQtyContainer":"VIP_DraftQuantity__draft-qty-container"};